import React, { useState } from "react";

import iconSet from "./icomoon/selection.json";
import IcoMoon from "react-icomoon";
import { AlertIcon } from "./icons/alert";

const Icon = (props) => <IcoMoon iconSet={iconSet} {...props} />;

const MESSAGE =
  "Your password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character. Spaces are not allowed.";

const PasswordInput = (props) => {
  const {
    onChange,
    name,
    label,
    validate,
    missmatch,
    autoComplete = false,
  } = props;
    const [shouldHide, setHide] = useState(true);
    const [password, setPassword] = useState("");
    const [hasError, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const type = shouldHide ? "password" : "text";
    const iconType = shouldHide ? "view-password" : "hide-password";
    const pattern = /^(?!.*\s)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
    return (
        <div
          className={`zds-form-item ${hasError ? "zds-form-item-error" : ""}`}
        >
            <label htmlFor={name} className="zds-form-label zds-form-label-large">
              {label}
              <span className="zds-form-label-required">*</span>
            </label>
            <div className="input-password-container">
                <input
                    type={type}
                    value={password}
                    onChange={(event) => {
                        const value = event.target.value;
                        setPassword(value);
                        if (value.trim() === "") {
                            setError(true);
                            setErrorMessage("Password is Required");
                            onChange("");
                            return;
                        }
                        if (validate && !pattern.test(value)) {
                            setError(true);
                            setErrorMessage(MESSAGE);
                            onChange("");
                            return;
                        }
                        setError(false);
                        setPassword(value);
                        onChange(value);
                    }}
                    className="zds-input-textfield zds-input-textfield-large"
                    name={name}
                    id={name}
                    autoComplete={autoComplete ? "current-password" : "new-password"}
                />
                <Icon
                  data-testid="show-password"
                  onClick={() => setHide(!shouldHide)}
                  iconSet={iconSet}
                  size={18}
                  icon={iconType}
                />
            </div>
            {(hasError || missmatch) && (
                <p className="zds-form-instructions zds-form-instructions-large">
                    <AlertIcon /> {missmatch ? "Password Missmatch" : errorMessage}
                </p>
            )}
        </div>
    );
};

export default PasswordInput;